import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider, GlobalStyles, CssBaseline } from '@mui/material';
import { RouterProvider } from 'react-router';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import router from '@/routes';
import { store } from '@/store';
import { theme } from '@/theme';
import globalStyles from './globalStyles';

const App = () => (
  <Provider store={store}>
    <CssBaseline />
    <GlobalStyles styles={globalStyles} />

    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <RouterProvider router={router} />
      </LocalizationProvider>
    </ThemeProvider>
  </Provider>
);

export default App;
